import React from "react";

import "./PlusButton.scss";

const PlusButton = () => {
  return <button className="movie-desc-container__plus">+</button>;
};
export default PlusButton;
